import React from 'react'

import {Icon} from '@vio/atlas/Icon'
import {Brand} from '@vio/core/src/brand/types'
import {checkIsBrandVio} from '@vio/core/src/brand/utils'

import {BrandLogo} from './BrandLogo'

const ICON_SIZE = 20

interface Props {
  /** Brand configuration. It can be one of our brands or a white-label brand. */
  brand: Brand
}

/**
 * Brand icon shown next to a page title. Vio uses the Atlas icon, which has a
 * transparent background, while other brands use their hosted compact icon.
 */
export const BrandTitleIcon = ({brand}: Props) =>
  checkIsBrandVio(brand) ? (
    <Icon name="VioIcon" size="md" />
  ) : (
    <BrandLogo compact brand={brand} height={ICON_SIZE} width={ICON_SIZE} />
  )
